var ezdia;
(function (ezdia) {
    var template = function (context) {
        var days = context.days, hours = context.hours, minutes = context.minutes, seconds = context.seconds;
        var ret = "<div class=\"ezdia-timer clearfix\">\n      " + (days
            ? "<div class=\"ezdia-timer__col\">\n        <span class=\"ezdia-timer__col__txt\">" + days + "</span>\n        <span class=\"ezdia-timer__col__label\">Days</span>\n      </div>"
            : '') + "\n      <div class=\"ezdia-timer__col\">\n        <span class=\"ezdia-timer__col__txt\">" + hours + "</span>\n        <span class=\"ezdia-timer__col__label\">h</span>\n      </div>\n      <div class=\"ezdia-timer__col ezdia-timer__col--separator\">:</div>\n      <div class=\"ezdia-timer__col\">\n        <span class=\"ezdia-timer__col__txt\">" + minutes + "</span>\n        <span class=\"ezdia-timer__col__label\">min</span>\n      </div>\n      <div class=\"ezdia-timer__col ezdia-timer__col--separator\">:</div>\n      <div class=\"ezdia-timer__col\">\n        <span class=\"ezdia-timer__col__txt\">" + seconds + "</span>\n        <span class=\"ezdia-timer__col__label\">sec</span>\n      </div>\n    </div>";
        return ret;
    };
    var templates;
    (function (templates) {
        templates.timer = {
            template: template
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
